<template>
    <div class="start-page">
        <div class="bg-wrap" @click="goHome">
            <!-- 版权信息移到背景层内，保证层级 -->
            <footer class="copyright">
                Copyright ©湖北省人才发展集团有限公司. All Rights Reserved
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        goHome() {
            this.$router.push('/home')
        }
    }
}
</script>

<style scoped lang="less">
.start-page {
    height: 100vh;
    display: flex;
    flex-direction: column;

    .bg-wrap {
        flex: 1;
        width: 100%;
        height: 100%;
        position: relative;
        cursor: pointer;
        /* 移动端默认背景图 */
        background: url('@/assets/start-pc.jpg') center/cover no-repeat;

        &::after {
            content: '';
            position: absolute;
            inset: 0;
            background: rgba(255, 255, 255, 0.3);
            z-index: 1;
        }

        // PC端媒体查询（屏幕宽度≥992px）
        @media (min-width: 992px) {
            background: url('@/assets/start-pc.jpg') center/cover no-repeat;
        }

        .copyright {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            font-size: 12px;
            color: #666;
            padding: 10px 0;
            text-align: center;
            z-index: 2;
        }
    }
}
</style>